import React, { useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import BaseForm from "./Form";
import DocumentHeader from "./DocumentHeader";
import { useNavigate } from "react-router-dom";

const AddDocument = () => {
  const [category, setCategory] = useState("student");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row custom-scroll-layout">
                  {/* LEFT */}
                  <div className="col-md-2 left-pane">
                    <DocumentHeader data="Documents Portal" />
                  </div>

                  <div className="col-md-10 right-pane">
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="text-primary m-0">Add Collection</h4>

                        <button
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => navigate(-1)}
                        >
                          ← Back
                        </button>
                      </div>

                      <div className="card-body">
                        {/* Category Selector */}
                        <div className="btn-group mb-4">
                          {["student", "enquiry", "marketing"].map((cat) => (
                            <button
                              key={cat}
                              className={`btn ${
                                category === cat
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                              }`}
                              onClick={() => setCategory(cat)}
                            >
                              {cat.toUpperCase()}
                            </button>
                          ))}
                        </div>

                        {/* Reuse Form */}
                        <BaseForm defaultCategory={category} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDocument;
